/* eslint-disable react/jsx-props-no-spreading */
import { FC, MouseEvent, useCallback, useState } from 'react';
import InputValueDisguise from './components/InputValueDisguise/InputValueDisguise';
import Input from '~/view/components/Controls/InputComponent/Input';
import { IInputProps, InputType, TInputType } from '~/view/components/Controls/InputComponent/types';

// eslint-disable-next-line unused-imports/no-unused-vars
const MaskedInput: FC<IInputProps> = ({ type, nextComponent, ...props }: IInputProps): JSX.Element => {
  const [inputType, setInputType] = useState<TInputType>(InputType.PASSWORD);

  const handleTypeChange = useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setInputType((prevType) => (prevType === InputType.TEXT ? InputType.PASSWORD : InputType.TEXT));
  }, []);

  return (
    <Input
      {...props}
      type={inputType}
      autoComplete="new-password"
      nextComponent={<InputValueDisguise type={inputType} onPress={handleTypeChange} />}
    />
  );
};

export default MaskedInput;
